// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-note {
  width: 250px;
}

.merge-chip {
  margin-left: 0.0825rem;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/inventory/parts/part-nbrs/part-nbrs.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AACA;EACI,sBAAA;AAEJ","sourcesContent":[".search-note {\n    width: 250px;\n}\n.merge-chip {\n    margin-left: .0825rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
